import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { EditorMetaModel } from 'src/app/models/document.model';

// Constants used for the calculation of the visibility of elements in the header.
const MAX_WIDTH_LEFT_PART_HEADER = 125;
const MAX_WIDTH_RIGHT_PART_HEADER = 455;
const LOGO_TEXT_WIDTH = 80;
const SAVE_DOCUMENT_TEXT_WIDTH = 108;

@Component({
  selector: 'tx-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements AfterViewInit, OnChanges {
  @Input() editorMeta!: EditorMetaModel;
  @Input() isDirty: boolean = false;
  @Input() initials: string = '';
  @Input() isLoading: boolean = false;


  @Output() onLogout = new EventEmitter();
  @Output() onSave = new EventEmitter();
  @Output() onDownload = new EventEmitter();
  @Output() onPrint = new EventEmitter();

  @ViewChild('header') header!: ElementRef;
  @ViewChild('contactAndCase') contactAndCase!: ElementRef;
  @ViewChild('fileName') fileName!: ElementRef;

  isDocumentLoaded = false;
  documenthasChanged = false;
  showLogoText = true;
  showSaveButtonText = true;
  stackContactAndCase = false;


  ngOnChanges(changes: SimpleChanges) {
    if (changes['editorMeta']) {
      this.isDocumentLoaded = !!this.editorMeta?.casDescription;
      this.documenthasChanged = true;
    }
  }

  ngAfterViewInit(): void {
    if (this.documenthasChanged) {
      this.calculateHeaderElementsVisibility();
      this.documenthasChanged = false;
    }
  }

  calculateHeaderElementsVisibility() {
    // Calculate the dynamic widths for the header.
    const headerWidth = this.header?.nativeElement?.clientWidth || 0;
    const contactAndCaseWidth = this.contactAndCase?.nativeElement?.clientWidth || 0;
    const fileNameWidth = this.fileName?.nativeElement?.clientWidth || 0;
    const documentInfoWidth = contactAndCaseWidth + fileNameWidth;
    const availableWidthOption0 = headerWidth - MAX_WIDTH_LEFT_PART_HEADER - MAX_WIDTH_RIGHT_PART_HEADER;
    const availableWidthOption1 = availableWidthOption0 + LOGO_TEXT_WIDTH;
    const availableWidthOption2 = availableWidthOption1 + SAVE_DOCUMENT_TEXT_WIDTH;

    // First reset values
    this.showLogoText = true;
    this.showSaveButtonText = true;
    this.stackContactAndCase = false;

    // We want to set visibility in a specific sequence of actions, dependant on if it fits.
    if (availableWidthOption0 < documentInfoWidth) {
      this.showLogoText = false;

      if (availableWidthOption1 < documentInfoWidth) {
        this.showSaveButtonText = false;

        if (availableWidthOption2 < documentInfoWidth) {
          this.stackContactAndCase = true;
        }
      }
    }
  }

  save() {
    this.onSave.emit();
    return false;
  }

  download() {
    this.onDownload.emit();
    return false;
  }

  print() {
    this.onPrint.emit();
    return false;
  }

  logout() {
    this.onLogout.emit();
  }

}
